import React, { useEffect, useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import { getSurroundingIndustriesList } from "../../Redux/Actions/surroundingIndutriesActions";
import { columnsSurroundingIndustries } from "../../Global Functions/columnsAntd";

const ListSurroundingIndustries = () => {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchSurroundingIndustriesDetails = (page, pageSize) => {
    const surroundingData = {
      page,
      limit: pageSize,
      filter: searchQuery,
    };
    dispatch(getSurroundingIndustriesList(surroundingData));
  };

  useEffect(() => {
    fetchSurroundingIndustriesDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { surroundingIndustries } = useSelector((state) => state.surroundingIndustries);
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  useEffect(() => {
    if (surroundingIndustries?.total) {
      setPagination((prevData) => ({ ...prevData, total: surroundingIndustries.total }));
    }
  }, [surroundingIndustries]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchSurroundingIndustriesDetails(pagination.current, pagination.pageSize);
  };

  const filterHandler = () => {
    setPagination((prevData) => ({ ...prevData, current: 1 }));
    fetchSurroundingIndustriesDetails(1, pagination.pageSize);
  };

  return (
    <TableComponent
      h3heading="Surrounding Industries List"
      dataSource={Array.isArray(surroundingIndustries?.data) ? surroundingIndustries.data : []}
      buttonhead2={canAdd ? "Add Surrounding Industry" : null}
      setState={setSearchQuery}
      filterFunction={filterHandler}
      navigateTo2={canAdd ? "/surrounding_industries/add" : null}
      onChange={handleTableChange}
      columns={columnsSurroundingIndustries}
      pagination={pagination}
    ></TableComponent>
  );
};

export default ListSurroundingIndustries;
